export enum LogicFlowStepExecutionStatusEnum {

    PENDING,
    RUNNING,
    COMPLETED,
    SKIPPED,
    FAILED,
    PAUSED,
}
